import cmp, {site} from "../context/context";
import {TCString} from "../tcstring/t-c-string";
import {Session} from "../session/session";
import {
    IPostRegister,
    IToPublicEvent,
    TEvent,
    TEventSubtype
} from "services-comun-meteored/modules/services/cmp/web/events";
import {log} from "../util/log";
import {EventManager} from "../api/event-manager";
import {isBot} from "services-comun/modules/browser/user-agent";

declare var TEST: boolean;
declare var DESARROLLO: boolean;

const SERVICIO: string = `https://${DESARROLLO ? `local-` : `${TEST ? 'test-' : ''}`}cmp.meteored.com/cmp/web/events/register`;

interface IUIEvent {
    date: Date;
    domain: string;
    country: string;
    lang: string;
    config: string;
    type: TEvent;
    subtype?: TEventSubtype;
    session?: string;
    cmp_version: number;
    gvl_version: number;
    tc_date: Date;
    tc_string?: string;
    bot: boolean;
}

export class UIEvent implements IUIEvent {
    /* STATIC */
    public static create(type: TEvent, subtype?: TEventSubtype): UIEvent {
        return new UIEvent({
            date: new Date(),
            domain: site.domain,
            country: site.country,
            lang: site.language,
            config: site.config,
            type,
            subtype,
            session: Session.get().key,
            cmp_version: cmp().version(),
            gvl_version: cmp().vendorList?.version??0,
            tc_date: (cmp().tcString as TCString).created,
            tc_string: cmp().tcString?.toString(),
            bot: isBot()
        });
    }

    /* INSTANCE */
    protected constructor(private readonly _data: IUIEvent) {
    }

    protected get data(): IUIEvent {
        return this._data;
    }

    public get date(): Date {
        return this.data.date;
    }

    public get domain(): string {
        return this.data.domain;
    }

    public get country(): string {
        return this.data.country;
    }

    public get lang(): string {
        return this.data.lang;
    }

    public get config(): string {
        return this.data.config;
    }

    public get type(): TEvent {
        return this.data.type;
    }

    public get subtype(): TEventSubtype|undefined {
        return this.data.subtype;
    }

    public get session(): string|undefined {
        return this.data.session;
    }

    public get cmp_version(): number {
        return this.data.cmp_version;
    }

    public get gvl_version(): number {
        return this.data.gvl_version;
    }

    public get tc_date(): Date {
        return this.data.tc_date;
    }

    public get tc_string(): string|undefined {
        return this.data.tc_string;
    }

    public get bot(): boolean {
        return this.data.bot;
    }

    public register(): void {
        this.registerAsync().then(() => {});
    }

    public async registerAsync(): Promise<void> {
        const post: IPostRegister = {
            event: this.data
        };
        await fetch(SERVICIO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(post)
        }).catch(() => {
            log.debug(`No se ha podido registrar el evento ${this.type} en el servidor`);
        });
    }

    public toPublic(): IToPublicEvent {
        return {
            type: this.type,
            subtype: this.subtype
        };
    }

    public notify(): void {
        EventManager.trigger(EventManager.EVENT_CMP_UI, this.toPublic());
    }
}
